export const SET_UNPAID_INVOICES = 'SetUnpaidInvoices';
export const SET_ACCOUNTS_PAYABLE_VENDORS = 'SetAccountPayableVendors';
export const SET_ACCOUNTS_PAYABLE_INVOICES = 'SetAccountPayableInvoices';
export const SET_ACCOUNTS_PAYABLE_SCHEDULES = 'SetAccountPayableSchedules';
export const SET_ACCOUNTS_PAYABLE_VENDORS_BY_NUMBER =
	'SetAccountPayableVendorsByNumber';
export const SET_ACCOUNTS_PAYABLE_VENDORS_BY_NAME =
	'SetAccountPayableVendorsByName';
export const SET_UNPAID_QUEUED_INVOICES = 'SetUnpaidQueuedInvoices';
export const SET_BANK_ACCOUNTS = 'SetBankAccounts';
export const SET_POSTED_INVOICE_RESULT = 'SetPostedInvoiceResult';
export const SET_PAYMENT_SELECTION = 'SetPaymentSelection';
export const SET_PAYMENT_SELECTIONALL = 'SetPaymentSelectionAll';
export const UPDATE_PAYMENT_SELECTIONALL = 'UpdatePaymentSelectionAll';
export const UPDATE_PAYMENT_SELECTION = 'UpdatePaymentSelection';
export const SAVE_UNPAID_QUEUED_INVOICES = 'SaveUnpaidQueuedInvoices';
export const SAVE_UNPAID_BULK_QUEUED_INVOICES = 'SaveUnpaidBulkQueuedInvoices';
export const UPDATE_ACCOUNTS_PAYABLE_PAYMENT_FILTERS =
	'UpdateAccountsPayablePaymentFilters';
export const REMOVE_UNPAID_FROM_QUEUED_INVOICES =
	'RemoveUnpaidFromQueuedInvoices';
export const SET_PRINT_ROWKEY = 'SetPrintRowKey';
export const SET_PRINT_BATCHNUMBER_URL = 'SetPrintBatchNumberURL';
export const UPDATE_ACCOUNTS_PAYABLE_RECONCILE_FILTERS =
	'UpdateAccountsPayableReconcileFilters';
export const SET_UNPAID_INVOICES_COUNTS = 'SetUnpaidInvoicesCounts';
export const SET_UNPAID_INVOICES_LOADED = 'SetUnpaidInvoicesLoaded';
export const LOCK_VENDORS_FOR_PROCESSING = 'LockVendorsForProcessing';
export const RELEASE_VENDORS_FOR_PROCESSING = 'ReleaseVendorsForProcessing';
export const SET_POSTING_MONTH_OPTIONS = 'setPostingMonthOptions';
export const SET_VENDOR_SUMMARIES = 'SetVendorSummaries';
export const SORT_VENDOR_SUMMARIES = 'SortVendorSummaries';
export const UPDATE_VENDOR_SUMMARIES = 'UpdateVendorSummaries';
export const UPDATE_VENDOR_SUMMARY_PROP = 'UpdateVendorSummaryProp';
export const SET_REFERENCE_NUMBERS = 'SetReferenceNumbers';
export const CLEAR_REFERENCE_NUMBERS = 'ClearReferenceNumbers';
export const SET_PAYMENT_METHODS = 'SetPaymentMethods';
export const SET_PAYMENT_METHODS_ENABLED = 'SetPaymentMethodsEnabled';
